import { Action } from '@ngrx/store';

export enum PumpPrimerActionTypes {
    LOAD_PUMP_PRIMER_VALUES = '[Pump Primer] Load Pump Primer Mix Default Values',
    LOAD_PUMP_PRIMER_VALUES_SUCCESS = '[Pump Primer] Load Pump Primer Mix Default Values Success',
    LOAD_PRIMER_SLUMP_VALUES = '[Pump Primer] Load Primer Slump Values',
    LOAD_PRIMER_SLUMP_VALUES_SUCCESS = '[Pump Primer] Load Primer Slump Values Success',
}

export class LoadPumpPrimerValues implements Action {
  readonly type = PumpPrimerActionTypes.LOAD_PUMP_PRIMER_VALUES;

  constructor(public payload: any) {}
}

export class LoadPumpPrimerValuesSuccess implements Action {
  readonly type = PumpPrimerActionTypes.LOAD_PUMP_PRIMER_VALUES_SUCCESS;

  constructor(public payload: any) {}
}

export class LoadPrimerSlumpValues implements Action {
  readonly type = PumpPrimerActionTypes.LOAD_PRIMER_SLUMP_VALUES;

  constructor(public payload: any) {}
}

export class LoadPrimerSlumpValuesSuccess implements Action {
  readonly type = PumpPrimerActionTypes.LOAD_PRIMER_SLUMP_VALUES_SUCCESS;

  constructor(public payload: any) {}
}

export type PumpPrimerActions =
  | LoadPumpPrimerValues
  | LoadPumpPrimerValuesSuccess
  | LoadPrimerSlumpValues
  | LoadPrimerSlumpValuesSuccess;
